import './exportable_table.js.coffee'
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PostInsightsView extends Monitoring.Reports.Campaign.ExportableTable
  include @, Monitoring.Reports.Campaign.Utils

  className: 'post-insights'
  template: JST['backbone/templates/monitoring/reports/campaign/post_insights']

  initialize: (@options = {}) =>
    @className = 'post-insights'

  render: ->
    @$el.addClass('processing')

    if @options.type == "instagramMedia"
      params = @paramsForChildsOfPosts
        exclude_page_owner_generated: true
      params = $.extend({}, params, { parent_id: @options.content_id }) if @options.content_id
      $.post('/monitoring/reports/campaign/instagramMedia_insights', params, @_renderData)

    else
      params = {
        account_id: @options.account_id,
        content_id: @options.content_id,
        user:       @options.user,
        date_from:  @options.date_from_ISO,
        date_to:    @options.date_to_ISO,
        exclude_page_owner_generated: true
      }
      if @options.summary
        $.post('/monitoring/reports/campaign/fb_summary', params, @_renderData)      
      else
        $.post('/monitoring/reports/campaign/' + @options.type + '_insights', params, @_renderData)
      
  _renderData: (data) =>
    super
    @$el
      .removeClass('processing')
      .append(@template({insights: data,type: @options.type,summary: @options.summary,getReactionName: @getReactionName,paginate: @options.paginate}))
    @trigger('rendered')

  getReactionName: (metric) ->
    if metric == 'likes'
      "like"
    else
      metric.split('_')[1]
